export const MAX_POST_CHARS = 800;
export const MAX_COMMENT_CHARS = 400;
export const FEED_CLAMP_LINES = 6;
export const MAX_PROFILE_INTERESTS = 15;
export const MAX_PROFILE_INTEREST_CHARS = 25;
export const MAX_PROFILE_BIO_CHARS = 1000;
export const LEGAL_TERMS_VERSION = '2026-03-02.1';
export const LEGAL_PRIVACY_VERSION = '2026-03-02.1';
export const LEGAL_COOKIE_VERSION = '2026-03-02.1';
